import React from "react";
import { Table, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const CustomTable = (props: any) => {
  return (
    <div className="custom-table">
      <Table
        bordered
        rowKey={(record) => record.key || record.id}
        // rowKey={props.rowKey}
        dataSource={props.data}
        columns={props.columns}
        size="small"
        pagination={props.pagination}
        onRow={(record) => ({
          onClick: () => {
            props.handleRowClick(record);
          },
        })}
        loading={props.loading}
        rowSelection={
          props.selectable
            ? {
                type: props.selectionType || "checkbox",
                onChange: props.handleSelectionChange,
                selectedRowKeys: props.selectedRowKeys,
              }
            : undefined
        }
        rowClassName={() => "cursor-pointer"}
        expandable={
          props.expandable
            ? {
                expandedRowRender: (_: any) => props.expandedRowContent(),
                rowExpandable: (record: any) =>
                  record.name !== "Not Expandable",
              }
            : undefined
        }
      />
      {props.withAddButton && (
        <Button
          type="dashed"
          onClick={props.handleAdd}
          icon={<PlusOutlined />}
          className="ms-auto mt-3"
        >
          {props.addButtonText ?? "Add"}
        </Button>
      )}
    </div>
  );
};

export default CustomTable;
